/* EVMT pack deals — TrueClassic-style quantity tiles.
 * Decorates the QUANTITY option pills with "Save $X" + "$X.XX/bottle" and a
 * BEST DEAL badge on the highest-savings pack, computed live from variant
 * data (per selected style/size). Re-applies after Dawn re-renders the picker.
 */
(function () {
  'use strict';

  function money(n) {
    return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
  }

  function getData() {
    if (window.__evmtProductData) return Promise.resolve(window.__evmtProductData);
    var m = window.location.pathname.match(/\/products\/[^\/]+/);
    if (!m) return Promise.reject(new Error('not a product page'));
    return fetch(m[0] + '.js').then(function (r) { return r.json(); }).then(function (d) {
      window.__evmtProductData = d;
      return d;
    });
  }

  function decorate(root, data) {
    var fieldsets = root.querySelectorAll('fieldset');
    var quantityFs = null, groups = [];
    fieldsets.forEach(function (fs) {
      var radios = fs.querySelectorAll('input[type="radio"]');
      if (!radios.length) return;
      groups.push(radios);
      var legend = fs.querySelector('legend');
      if (legend && /quantity/i.test(legend.textContent)) quantityFs = { fs: fs, radios: radios, idx: groups.length - 1 };
    });
    if (!quantityFs) return;

    // current selections for non-quantity options
    var current = groups.map(function (radios) {
      var c = Array.prototype.find.call(radios, function (i) { return i.checked; });
      return c ? c.value : null;
    });

    // idempotence guard: skip if already decorated for this selection —
    // otherwise our own DOM writes re-trigger the MutationObserver forever
    var sig = current.join('|');
    if (root.dataset.evmtDealsSig === sig && root.querySelector('.evmt-deal')) return;
    root.dataset.evmtDealsSig = sig;

    // candidate variants: match all options except quantity
    var packs = {};
    var bestSave = 0, bestValue = null;
    data.variants.forEach(function (v) {
      var o = [v.option1, v.option2, v.option3];
      var ok = current.every(function (c, i) {
        return i === quantityFs.idx || c === null || o[i] === c;
      });
      if (!ok || !v.available) return;
      var qty = o[quantityFs.idx];
      var count = parseInt(qty, 10) || 1;
      var price = v.price / 100;
      var cap = (v.compare_at_price || 0) / 100;
      var save = cap > price ? cap - price : 0;
      packs[qty] = { save: save, unit: price / count, count: count };
      if (save > bestSave) { bestSave = save; bestValue = qty; }
    });

    quantityFs.radios.forEach(function (input) {
      var label = quantityFs.fs.querySelector('label[for="' + input.id + '"]');
      if (!label) return;
      var old = label.querySelector('.evmt-deal');
      if (old) old.remove();
      label.classList.remove('evmt-best-deal');
      var p = packs[input.value];
      if (!p) return;
      var bits = [];
      if (p.save > 0.5) bits.push('<span class="evmt-deal__save">Save ' + money(p.save) + '</span>');
      if (p.count > 1) bits.push('<span class="evmt-deal__unit">' + money(p.unit) + '/bottle</span>');
      if (!bits.length) return;
      var el = document.createElement('span');
      el.className = 'evmt-deal';
      if (input.value === bestValue && bestSave > 0.5) {
        label.classList.add('evmt-best-deal');
        el.innerHTML = '<span class="evmt-deal__badge">BEST DEAL</span>' + bits.join('');
      } else {
        el.innerHTML = bits.join('');
      }
      label.appendChild(el);
    });
  }

  function run() {
    var root = document.querySelector('variant-selects, variant-radios');
    if (!root) return;
    getData().then(function (d) { decorate(root, d); }).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', run);
  run();

  // Dawn swaps picker HTML on every variant change — re-decorate afterwards
  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(run, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
